import { SVGProps, Ref, forwardRef } from 'react'
const SvgCyberscout = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    width="1.5rem"
    height="1.5rem"
    fill="none"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    {...props}
  >
    <path fill="currentColor" d="m16.054 9.526-.034-.077.265-.154-.23.231Z" />
    <path
      fill="currentColor"
      d="M12.004 16.733A4.739 4.739 0 0 0 16.74 12c0-.146-.008-.283-.017-.42l2.072-.958c.094.454.154.924.154 1.386 0 3.827-3.116 6.942-6.944 6.942-3.827 0-6.944-3.115-6.944-6.941 0-3.826 3.117-6.942 6.944-6.942 1.85 0 3.596.719 4.906 2.029l.454.453-1.558 1.558-.454-.454a4.71 4.71 0 0 0-3.348-1.386A4.739 4.739 0 0 0 7.27 12a4.739 4.739 0 0 0 4.735 4.733Z"
    />
    <path
      fill="currentColor"
      d="M21.8 12a9.61 9.61 0 0 0-.369-2.61l2.004-.934C23.795 9.603 24 10.802 24 12c0 6.616-5.377 12-11.996 12C5.386 24 0 18.616 0 12S5.386 0 12.004 0c3.031 0 5.917 1.13 8.134 3.175l.3.283-.77 2.354-.737-.736a9.729 9.729 0 0 0-6.927-2.868C6.602 2.208 2.21 6.6 2.21 12c0 5.4 4.393 9.792 9.795 9.792 5.403 0 9.795-4.391 9.795-9.792Z"
    />
  </svg>
)
const ForwardRef = forwardRef(SvgCyberscout)
export default ForwardRef
